<template >
  <v-container p-0 m-0 class="autoCompleteAnaContainer">
    <v-autocomplete
    :disabled="disabled"
      style="border: 0px solid red; margin: 0"
      v-if="lpa.mappedTipoAna == 'PR' || lpa.mappedTipoAna == 'IMP'"
      p-0
      m-0
      placeholder="find.."
      v-model="selectedtItem"
      @change="handleChangePrgAna"
      @update:search-input="autoCompleteChangeAna"
      :items="lookupAna.items"
      @keyup="keyDownAna"
      no-filter
      hide-details
      dense
      hide-no-data
      height="3em"
    >
      <template slot="prepend-item">
        <div class="divPlus">
          <v-btn
            class="btnPlus"
            color="primary"
            v-on:click="openDialogNewAna(lpa)"
            x-small
            height="1rem"
          >
            <v-icon x-small>mdi-plus</v-icon>
          </v-btn>
        </div>
      </template>

      <template slot="selection" slot-scope="{ item }">
        {{ item.prg }}
      </template>
      <template slot="item" slot-scope="{ item }">
        <span class="freeListItem">
          {{ item.des }} - {{ item.indirizzo }}
        </span>
      </template>
    </v-autocomplete>
    <!-- VR-->
    <v-autocomplete
    :disabled="disabled"
      style="border: 0px solid red; margin: 0"
      v-if="lpa.mappedTipoAna == 'VR'"
      p-0
      m-0
      placeholder="find.."
      v-model="selectedItemVr"
      @change="handleChangePrgAna"
      @update:search-input="autoCompleteChangeVr"
      :items="lookupVr.items"
      @keyup="keyDownAna"
      no-filter
      hide-details
      dense
      hide-no-data
      height="3em"
    >
      <template slot="prepend-item">
        <div class="divPlus">
          <v-btn
            class="btnPlus"
            color="primary"
            v-on:click="openDialogNewAna(lpa)"
            x-small
            height="1rem"
          >
            <v-icon x-small>mdi-plus</v-icon>
          </v-btn>
        </div>
      </template>

      <template slot="selection" slot-scope="{ item }">
        {{ item.prgIndirizzo }}
      </template>
      <template slot="item" slot-scope="{ item }">
        <span class="freeListItem">
          {{ item.desNum }}
        </span>
      </template>
    </v-autocomplete>
  </v-container>
</template>
<script>
import { rilieviService } from "../services/RilieviService.js";
export default {
  name: "AutoCompleteAna",
  props: {
    rilievo: {
      type: Object,
      required: true,
    },
    lpa: {
      type: Object,
      required: true,
    },
    currentPrgComune: {
      type: Number,
      required: true,
    },
    currentPrgAc: {
      type: Number,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default:false
      
    }
  },
  //props: ["rilievo","lpa","currentPrgComune","currentPrgAc"],

  data() {
    return {
      selectedtItem: { prg: "-1", des: "xxxxxxxx" },

      selectedItemVr: { prg: "-1", des: "xxxxxxxx" },
      lookupAna: {
        query: "",
        items: [],
      },
      lookupVr: {
        query: "",
        items: [],
      },
    };
  },

  created() {},
  mounted() {},
  methods: {
    handleChangePrgAna(item) {
      //alert(JSON.stringify(item));
      if (this.lpa.mappedTipoAna == "VR") {
        this.$emit(
          "onItemSelected",
          this.rilievo,
          this.lpa,
          this.selectedItemVr
        );
        this.selectedItemVr = null;
      } else {
        this.$emit(
          "onItemSelected",
          this.rilievo,
          this.lpa,
          item
        );
        this.selectedtItem = null;
      }
    },
    openDialogNewAna() {
      const arg={};
      arg.rilievo=this.rilievo;
      arg.lpa=this.lpa;
      this.$emit("opemDialogNewAna", arg);
    },

    keyDownAna(keyevent) {
      if (keyevent.key == "+") {
        this.openDialogNewAna(this.lpa);
      }
    },
    autoCompleteChange(searchInput) {
      if (this.tipoAna == "VR") {
        this.autoCompleteChangeVr(searchInput);
      } else {
        this.autoCompleteChangeAna(searchInput);
      }
    },
    autoCompleteChangeAna(searchInput) {
      if (searchInput != null) {
        if (this.lookupAna.query !== searchInput) {
          this.lookupAna.query = searchInput;
          this.doLookupAna(searchInput);
        }
      }
    },
    autoCompleteChangeVr(searchInput) {
      if (searchInput != null) {
        if (this.lookupVr.query !== searchInput) {
          this.lookupVr.query = searchInput;
          this.doLookupVr(searchInput);
        }
      }
    },

    async doLookupVr(query) {
      rilieviService.lookupVr(this.currentPrgAc, query, 1, 4).then((x) => {
        //alert(this.search);
        //alert(JSON.stringify(x))
        //this.lista.items.splice(0, this.lista.items.length);
        this.lookupVr.items = [];

        for (let index = 0; index < x.items.length; index++) {
          const item = x.items[index];
          const prgIndirizzo = item.prgInd;
          const desNum = item.desNum;
          const prgAc = item.prgAc;
          const desAc = item.desAc;
          //const des = item.des;
          const lookupItem = { prgIndirizzo, desNum, prgAc, desAc };
          this.lookupVr.items.push(lookupItem);
        }
      });
    },

    async doLookupAna(query) {
      rilieviService
        .lookupAna(this.lpa.mappedTipoAna, query, 1, 5)
        .then((x) => {
          this.lookupAna.items = [];

          for (let index = 0; index < x.items.length; index++) {
            const item = x.items[index];
            const prg = item.prg;
            const des = item.des;
            const indirizzo = item.indirizzo;
            //const des = item.des;
            const lookupItem = { prg, des, indirizzo };
            this.lookupAna.items.push(lookupItem);
          }
        });
    },
  },
};
</script>
<style scoped>
.divPlus {
  text-align: right;
  margin: 0 !important;
  padding: 0 !important;
  line-height: 0.4rem;
}
/* altezza delle autocomplete */
.v-text-field.v-text-field .v-input__control {
  _max-height: 25px;
  padding: 0;
}
.v-list {
  padding: 0rem !important;
}
.autoCompleteAnaContainer{
    padding: 0;
}
</style>